<template>
  <div class="bottom-banner" @click="$emit('open-form')">
    <div class="banner-link">
      <div class="banner-content">
        <div class="badge-wrap">
          <span class="badge hot">HOT</span>
          <span class="badge limited">매주</span>
        </div>
        <div class="text-wrap">
          <span class="sub-text">매주 달라지는 풍성한 상품</span>
          <strong class="main-text">경품 大 잔치</strong>
        </div>
        <div class="arrow-wrap">
          <span class="double-arrow">»</span>
        </div>
      </div>
      <div class="shine-effect"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileBottomBanner',
  emits: ['open-form']
}
</script>

<style scoped>
.bottom-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 980;
}

.banner-link {
  display: block;
  background: linear-gradient(90deg, #ff4757 0%, #ff6b81 50%, #ff4757 100%);
  background-size: 200% 100%;
  animation: gradientMove 2s ease infinite;
  padding: 14px 20px;
  text-decoration: none;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

@keyframes gradientMove {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  position: relative;
  z-index: 2;
}

.badge-wrap {
  display: flex;
  gap: 5px;
}

.badge {
  font-size: 10px;
  font-weight: 800;
  padding: 3px 7px;
  border-radius: 3px;
  animation: bounce 0.6s ease infinite;
}

.badge.hot {
  background: #ffd700;
  color: #d63031;
}

.badge.limited {
  background: #fff;
  color: #ff4757;
  animation-delay: 0.3s;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}

.text-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
}

.sub-text {
  font-size: 13px;
  font-weight: 500;
}

.main-text {
  font-size: 17px;
  font-weight: 800;
  color: #ffd700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  animation: pulse 1s ease infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.arrow-wrap {
  display: flex;
  align-items: center;
}

.double-arrow {
  font-size: 22px;
  color: #fff;
  font-weight: 800;
  animation: slideRight 0.8s ease infinite;
}

@keyframes slideRight {
  0%, 100% { transform: translateX(0); opacity: 1; }
  50% { transform: translateX(5px); opacity: 0.7; }
}

/* 빛나는 효과 */
.shine-effect {
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shine 2s ease infinite;
}

@keyframes shine {
  0% { left: -100%; }
  100% { left: 200%; }
}

/* 테두리 깜빡임 */
.banner-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ffd700, #fff, #ffd700);
  animation: borderPulse 1s ease infinite;
}

@keyframes borderPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* 작은 화면 */
@media (max-width: 380px) {
  .sub-text {
    font-size: 11px;
  }
  
  .main-text {
    font-size: 15px;
  }
  
  .badge {
    font-size: 9px;
    padding: 2px 5px;
  }
}
</style>